import {FlexBox, useBreakpoint} from '@brg/ui';
import {FC, useMemo, ReactNode} from 'react';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { LinksItems } from 'shared/components/slideNavigation/slideNavigation';
import {checkIsVisibleSorting} from "../../../helpers/designer/checkIsVisibleSorting";
import { LayoutConst } from 'core';
import { useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { getPathContext } from 'core/helpers/getPathContext';
import { AppTester } from 'supporting';
import { DesignerTab } from 'shared/constants/designerTab';
import styled from 'styled-components';

export const ADDITIONAL_TABS_SIGN = 'working_materials';

const SliderMobileWrapper = styled(FlexBox)`
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100% + 20px);
        margin-left: -10px;
    }
`

const AdditionalSliderWrapper = styled(FlexBox)`
    margin-top: 16px;

    @media (max-width: 1199px) {
        margin-top: 16px;
        margin-bottom: 16px;
    }
`

export const DesignerSliderItem: FC<{
    items?: Record<string, ReactNode | string | LinksItems>;
    additionalItems?: Record<string, string>;
    onChange?: (indexKey: string, additionalKey?: string ) => void;
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    overflowX?: boolean;
    isMe?: boolean;
    oneLineSorting?: boolean;
    addTab?: string,
    sortBar?: any;
    singleRow?: boolean;
    border?: string;
    autoWidth?: boolean;
}> = ({
  onChange,
  items,
  additionalItems,
  activeIndexKey,
  isLoading,
  whiteTheme,
  overflowX,
  isMe,
  oneLineSorting,
  addTab,
  sortBar,
  singleRow,
  border = '1px solid #CDCDCD',
  autoWidth,
}) => {

    const is940 = useBreakpoint(LayoutConst.screen.md);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const isTab = useBreakpoint(LayoutConst.screen.l);
    const isProfile = !!useRouteMatch(LinkTo.designer);
    const {application} = getPathContext();
    const isBooksGallllery = AppTester.isBooksGallllery();

    //todo make less complicated
    const meTabs = useMemo(() => (isMe ? {
        ...(items?.['competitions'] ? { competitions: items?.['competitions'] } : {}),
        ...(items?.['bookmarks'] ? { bookmarks: items?.['bookmarks'] } : {}),
        ...(items?.['drafts'] ? { drafts: items?.['drafts'] } : {}),
        ...(items?.['draft_books'] ? { draft_books: items?.['draft_books'] } : {}),
        ...(items?.['banned_projects'] ? { banned_projects: items?.['banned_projects'] } : {}),
        ...(items?.['private'] ? { private: items?.['private'] } : {}),
        ...(items?.['draft_presentation'] ? { draft_presentation: items?.['draft_presentation'] } : {}),
        ...(items?.['lms'] ? { lms: items?.['lms'] } : {}),
    } : {}), [items, isMe])

    const tabs = useMemo(() => {
        let list = {};
        for (let key in items) {
            if (!['competitions', 'bookmarks', 'drafts', 'draft_books', 'rejected', 'banned_projects', 'private', 'draft_presentation', 'lms']?.includes(key)) {
                //@ts-ignore
                list[key] = items[key]
            }
        }
        if (list && application.includes('ageytomesh')) {
            return Object.entries(list).filter((item: any) => {
                console.log('entry item', item)
                return !['students', 'organizations', 'jury'].includes(item[0])
            }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return list
    }, [items])


    const addTabsSign = useMemo(
        () => (activeIndexKey === ADDITIONAL_TABS_SIGN || activeIndexKey === DesignerTab.subscribe)
    , [activeIndexKey])

    const additionalTabs = useMemo(() => {
        if (additionalItems && application.includes('ageytomesh')) {
        return Object.entries(additionalItems).filter((item: any) => {
            return !['students', 'organizations', 'jury'].includes(item[0])
        }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return additionalItems
    }, [additionalItems, application])

    const tabsLenght = useMemo(() => (Object.keys(tabs)?.length), [tabs]);
 
    const hasTabs = useMemo(() => !!Object.keys(meTabs)?.length, [meTabs]);
    //@ts-ignore
    const hasAddTabs = useMemo(() => tabs && !!Object.keys(tabs)?.length, [tabs]);
    const isVisibleSorting = useMemo(() => checkIsVisibleSorting(activeIndexKey || ""), [activeIndexKey]);

    const showOneLineSorting = useMemo(() => (oneLineSorting || (isVisibleSorting && Object.keys(tabs)?.length <= 10 && !is940)), [isVisibleSorting, tabsLenght, is940, tabs, oneLineSorting])

    const mobileTabs = useMemo(() => {
        const allTabs = {
            ...(isMe && hasTabs? meTabs : {}),
            ...(hasAddTabs? tabs : {}),
            ...(additionalTabs && addTabsSign? additionalTabs : {})
        }
        return allTabs
    }, [isMe, hasTabs, meTabs, hasAddTabs, tabs, additionalTabs, addTabsSign])

    if (singleRow) {
        if (sortBar) {
            return (
                <SliderMobileWrapper
                    width="100%"
                    maxWidth="100%"
                    direction="column"
                    style={{ gap: 12, minWidth: 0, boxSizing: 'border-box'}}
                >
                    {/* Табы с горизонтальным скроллом */}
                    <FlexBox width="100%" style={{ overflowX: 'auto', overflowY: 'hidden'}}>
                        <SlideNavigation
                            isDesigner
                            items={items}
                            activeIndexKey={activeIndexKey}
                            onChange={onChange}
                            whiteTheme={whiteTheme}
                            maxVisibleItems={5}
                            showActiveTabUnderline={true}
                            border={border}
                        />
                    </FlexBox>
                    {/* SortBar под табами */}
                    <FlexBox width="100%" justify="flex-start" align="center">
                        {sortBar}
                    </FlexBox>
                </SliderMobileWrapper>

            );
        }

        return (
            <SliderMobileWrapper width={autoWidth ? 'auto' : '100%'}>
                <SlideNavigation
                    isDesigner
                    items={items}
                    activeIndexKey={activeIndexKey}
                    onChange={onChange}
                    whiteTheme={whiteTheme}
                    maxVisibleItems={5}
                    showActiveTabUnderline={true}
                    border={border}
                    autoWidth={autoWidth}
                />
            </SliderMobileWrapper>
        );
    }

    return (
        <SliderMobileWrapper direction='column' width='100%'>
        {    isMobile?
                <FlexBox offsetBottom={0}>
                    <SlideNavigation
                        isDesigner
                        items={items}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        // smallTab
                        dropdownWhiteTheme={isBooksGallllery}
                    />
                </FlexBox>
                :
            <>
            {isMe && hasTabs && (
                <FlexBox offsetBottom={16} >
                    <SlideNavigation
                        isDesigner
                        items={meTabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        // smallTab
                        dropdownWhiteTheme={isBooksGallllery}
                    />
                </FlexBox>
            )}
            <FlexBox
                width='100%'
                direction={showOneLineSorting ? 'row' : 'column'}
                justify={showOneLineSorting ? 'space-between' : 'flex-end'}
                offsetBottom={(isMe && hasTabs && !isProfile) ? 16 : 0}
            >
                {/*тут*/}
                {hasAddTabs && (
                    <FlexBox align='center' width={'100%'}>
                    <SlideNavigation
                        isDesigner
                        items={tabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        dropdownWhiteTheme={whiteTheme}
                        maxVisibleItems={isTab? 4 : 5}
                    />
                    {sortBar}
                    </FlexBox>
                )}

                {/*@ts-ignore*/}
                {
                !showOneLineSorting &&
                    additionalTabs &&
                    Object.keys(additionalTabs)?.length !== 0 &&
                    addTabsSign &&
                    isVisibleSorting &&
                <AdditionalSliderWrapper
                    direction={'row'}
                    height={22}
                >
                    {!showOneLineSorting && additionalTabs && addTabsSign && (
                        <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange(activeIndexKey ?? '', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                    )}
                </AdditionalSliderWrapper>}
            </FlexBox>
            {addTabsSign && additionalTabs && showOneLineSorting && (
                <AdditionalSliderWrapper>
                     <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange(activeIndexKey ?? '', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                </AdditionalSliderWrapper>
            )}
            </>
        }
        </SliderMobileWrapper>
    )
}import {FlexBox, useBreakpoint} from '@brg/ui';
import {FC, useMemo, ReactNode} from 'react';
import { SlideNavigation } from 'shared/components/slideNavigation';
import { LinksItems } from 'shared/components/slideNavigation/slideNavigation';
import {checkIsVisibleSorting} from "../../../helpers/designer/checkIsVisibleSorting";
import { LayoutConst } from 'core';
import { useRouteMatch } from 'react-router-dom';
import { LinkTo } from 'shared/constants/linkTo';
import { getPathContext } from 'core/helpers/getPathContext';
import { AppTester } from 'supporting';
import { DesignerTab } from 'shared/constants/designerTab';
import styled from 'styled-components';

export const ADDITIONAL_TABS_SIGN = 'working_materials';

const SliderMobileWrapper = styled(FlexBox)`
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
        width: calc(100% + 20px);
        margin-left: -10px;
    }
`

const AdditionalSliderWrapper = styled(FlexBox)`
    margin-top: 16px;

    @media (max-width: 1199px) {
        margin-top: 16px;
        margin-bottom: 16px;
    }
`

export const DesignerSliderItem: FC<{
    items?: Record<string, ReactNode | string | LinksItems>;
    additionalItems?: Record<string, string>;
    onChange?: (indexKey: string, additionalKey?: string ) => void;
    activeIndexKey?: string;
    isLoading?: boolean;
    whiteTheme?: any;
    overflowX?: boolean;
    isMe?: boolean;
    oneLineSorting?: boolean;
    addTab?: string,
    sortBar?: any;
    singleRow?: boolean;
    border?: string;
    autoWidth?: boolean;
}> = ({
  onChange,
  items,
  additionalItems,
  activeIndexKey,
  isLoading,
  whiteTheme,
  overflowX,
  isMe,
  oneLineSorting,
  addTab,
  sortBar,
  singleRow,
  border = '1px solid #CDCDCD',
  autoWidth,
}) => {

    const is940 = useBreakpoint(LayoutConst.screen.md);
    const isMobile = useBreakpoint(LayoutConst.screen.s - 1);
    const isTab = useBreakpoint(LayoutConst.screen.l);
    const isProfile = !!useRouteMatch(LinkTo.designer);
    const {application} = getPathContext();
    const isBooksGallllery = AppTester.isBooksGallllery();

    //todo make less complicated
    const meTabs = useMemo(() => (isMe ? {
        ...(items?.['competitions'] ? { competitions: items?.['competitions'] } : {}),
        ...(items?.['bookmarks'] ? { bookmarks: items?.['bookmarks'] } : {}),
        ...(items?.['drafts'] ? { drafts: items?.['drafts'] } : {}),
        ...(items?.['draft_books'] ? { draft_books: items?.['draft_books'] } : {}),
        ...(items?.['banned_projects'] ? { banned_projects: items?.['banned_projects'] } : {}),
        ...(items?.['private'] ? { private: items?.['private'] } : {}),
        ...(items?.['draft_presentation'] ? { draft_presentation: items?.['draft_presentation'] } : {}),
        ...(items?.['lms'] ? { lms: items?.['lms'] } : {}),
    } : {}), [items, isMe])

    const tabs = useMemo(() => {
        let list = {};
        for (let key in items) {
            if (!['competitions', 'bookmarks', 'drafts', 'draft_books', 'rejected', 'banned_projects', 'private', 'draft_presentation', 'lms']?.includes(key)) {
                //@ts-ignore
                list[key] = items[key]
            }
        }
        if (list && application.includes('ageytomesh')) {
            return Object.entries(list).filter((item: any) => {
                console.log('entry item', item)
                return !['students', 'organizations', 'jury'].includes(item[0])
            }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return list
    }, [items])


    const addTabsSign = useMemo(
        () => (activeIndexKey === ADDITIONAL_TABS_SIGN || activeIndexKey === DesignerTab.subscribe)
    , [activeIndexKey])

    const additionalTabs = useMemo(() => {
        if (additionalItems && application.includes('ageytomesh')) {
        return Object.entries(additionalItems).filter((item: any) => {
            return !['students', 'organizations', 'jury'].includes(item[0])
        }).reduce((a,[k,v]) => ({...a, [k]: v}), {})
        }
        return additionalItems
    }, [additionalItems, application])

    const tabsLenght = useMemo(() => (Object.keys(tabs)?.length), [tabs]);
 
    const hasTabs = useMemo(() => !!Object.keys(meTabs)?.length, [meTabs]);
    //@ts-ignore
    const hasAddTabs = useMemo(() => tabs && !!Object.keys(tabs)?.length, [tabs]);
    const isVisibleSorting = useMemo(() => checkIsVisibleSorting(activeIndexKey || ""), [activeIndexKey]);

    const showOneLineSorting = useMemo(() => (oneLineSorting || (isVisibleSorting && Object.keys(tabs)?.length <= 10 && !is940)), [isVisibleSorting, tabsLenght, is940, tabs, oneLineSorting])

    const mobileTabs = useMemo(() => {
        const allTabs = {
            ...(isMe && hasTabs? meTabs : {}),
            ...(hasAddTabs? tabs : {}),
            ...(additionalTabs && addTabsSign? additionalTabs : {})
        }
        return allTabs
    }, [isMe, hasTabs, meTabs, hasAddTabs, tabs, additionalTabs, addTabsSign])

    if (singleRow) {
        if (sortBar) {
            return (
                <SliderMobileWrapper
                    width="100%"
                    maxWidth="100%"
                    direction="column"
                    style={{ gap: 12, minWidth: 0, boxSizing: 'border-box'}}
                >
                    {/* Табы с горизонтальным скроллом */}
                    <FlexBox width="100%" style={{ overflowX: 'auto', overflowY: 'hidden'}}>
                        <SlideNavigation
                            isDesigner
                            items={items}
                            activeIndexKey={activeIndexKey}
                            onChange={onChange}
                            whiteTheme={whiteTheme}
                            maxVisibleItems={5}
                            showActiveTabUnderline={true}
                            border={border}
                        />
                    </FlexBox>
                    {/* SortBar под табами */}
                    <FlexBox width="100%" justify="flex-start" align="center">
                        {sortBar}
                    </FlexBox>
                </SliderMobileWrapper>

            );
        }

        return (
            <SliderMobileWrapper width={autoWidth ? 'auto' : '100%'}>
                <SlideNavigation
                    isDesigner
                    items={items}
                    activeIndexKey={activeIndexKey}
                    onChange={onChange}
                    whiteTheme={whiteTheme}
                    maxVisibleItems={5}
                    showActiveTabUnderline={true}
                    border={border}
                    autoWidth={autoWidth}
                />
            </SliderMobileWrapper>
        );
    }

    return (
        <SliderMobileWrapper direction='column' width='100%'>
        {    isMobile?
                <FlexBox offsetBottom={0}>
                    <SlideNavigation
                        isDesigner
                        items={items}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        // smallTab
                        dropdownWhiteTheme={isBooksGallllery}
                    />
                </FlexBox>
                :
            <>
            {isMe && hasTabs && (
                <FlexBox offsetBottom={16} >
                    <SlideNavigation
                        isDesigner
                        items={meTabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        // smallTab
                        dropdownWhiteTheme={isBooksGallllery}
                    />
                </FlexBox>
            )}
            <FlexBox
                width='100%'
                direction={showOneLineSorting ? 'row' : 'column'}
                justify={showOneLineSorting ? 'space-between' : 'flex-end'}
                offsetBottom={(isMe && hasTabs && !isProfile) ? 16 : 0}
            >
                {/*тут*/}
                {hasAddTabs && (
                    <FlexBox align='center' width={'100%'}>
                    <SlideNavigation
                        isDesigner
                        items={tabs}
                        activeIndexKey={activeIndexKey}
                        onChange={onChange}
                        whiteTheme={whiteTheme}
                        overflowX={overflowX}
                        dropdownWhiteTheme={whiteTheme}
                        maxVisibleItems={isTab? 4 : 5}
                    />
                    {sortBar}
                    </FlexBox>
                )}

                {/*@ts-ignore*/}
                {
                !showOneLineSorting &&
                    additionalTabs &&
                    Object.keys(additionalTabs)?.length !== 0 &&
                    addTabsSign &&
                    isVisibleSorting &&
                <AdditionalSliderWrapper
                    direction={'row'}
                    height={22}
                >
                    {!showOneLineSorting && additionalTabs && addTabsSign && (
                        <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange(activeIndexKey ?? '', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                    )}
                </AdditionalSliderWrapper>}
            </FlexBox>
            {addTabsSign && additionalTabs && showOneLineSorting && (
                <AdditionalSliderWrapper>
                     <SlideNavigation
                         isDesigner
                         items={additionalTabs}
                         activeIndexKey={addTab}
                         onChange={(value) => {
                            onChange && onChange(activeIndexKey ?? '', value)
                         }}
                         whiteTheme={whiteTheme}
                         overflowX={overflowX}
                         smallTab
                     />
                </AdditionalSliderWrapper>
            )}
            </>
        }
        </SliderMobileWrapper>
    )
}